import React, { useState } from "react";
import { TimeSliderProps } from "./TimeSlider.types";
import { COLORS } from "../../theme";

export function TimeSlider({
    imageIndex,
    setImageIndex,
    isPlaying,
    setIsPlaying,
    totalImages,
    intervalMs = 600,
    fdlmcpParams,
    formParams
}: TimeSliderProps) {
    const [isAnimating, setIsAnimating] = useState(false);

    // Calculate date/time for current imageIndex
    let dateStr: string;
    if (fdlmcpParams) {
        // Use fdlmcp parameters to calculate date/time
        const base = new Date(Date.UTC(fdlmcpParams.year, fdlmcpParams.month - 1, fdlmcpParams.day, 0, 0, 0, 0));
        const d = new Date(base.getTime() + imageIndex * 15 * 60 * 1000);
        const pad = (n: number) => n.toString().padStart(2, "0");
        dateStr = `${d.getUTCFullYear()}/${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
    } else if (formParams) {
        // Fallback to form parameters if fdlmcpParams is not available
        const base = new Date(Date.UTC(formParams.year, formParams.month - 1, formParams.day, 0, 0, 0, 0));
        const d = new Date(base.getTime() + imageIndex * 15 * 60 * 1000);
        const pad = (n: number) => n.toString().padStart(2, "0");
        dateStr = `${d.getUTCFullYear()}/${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
    } else {
        // Fallback to default calculation
        const base = new Date(Date.UTC(2014, 0, 1, 0, 0, 0, 0));
        const d = new Date(base.getTime() + imageIndex * 15 * 60 * 1000);
        const pad = (n: number) => n.toString().padStart(2, "0");
        dateStr = `${d.getUTCFullYear()}/${pad(d.getUTCMonth() + 1)}/${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 320 }}>
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <button
                    onClick={e => {
                        setIsAnimating(true);
                        setIsPlaying(p => !p);
                    }}
                    style={{
                        marginRight: 12,
                        background: "none",
                        border: "none",
                        color: "white",
                        fontSize: 22,
                        cursor: "pointer",
                        outline: "none",
                        fontFamily: "Arial, sans-serif"
                    }}
                    aria-label={isPlaying ? "Pause animation" : "Play animation"}
                    className={isAnimating ? 'icon-collapse-animate' : ''}
                    onAnimationEnd={() => setIsAnimating(false)}
                >
                    {isPlaying ? (
                        // Pause SVG
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="6" y="4" width="4" height="16" rx="1" />
                            <rect x="14" y="4" width="4" height="16" rx="1" />
                        </svg>
                    ) : (
                        // Play SVG
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polygon points="6,4 20,12 6,20 6,4" fill="white" />
                        </svg>
                    )}
                </button>
                <input
                    type="range"
                    min={0}
                    max={totalImages - 1}
                    value={imageIndex}
                    onChange={e => {
                        setImageIndex(Number(e.target.value));
                        setIsPlaying(false);
                    }}
                    style={{
                        flex: 1,
                        marginRight: 12,
                        accentColor: COLORS.focusBorder,
                        height: 6,
                        borderRadius: 6,
                        background: COLORS.background,
                        WebkitAppearance: 'none', // This hides the default browser styling for the range input, allowing custom styles.
                        fontFamily: "Arial, sans-serif"
                    }}
                />
                <span style={{ color: "#ccc", fontSize: 13, minWidth: 32, textAlign: "right", fontFamily: "Arial, sans-serif" }}>
                    {imageIndex + 1} / {totalImages}
                </span>
            </div>
            {/* Date/time below slider */}
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginTop: 4 }}>
                <span style={{
                    color: "#ccc",
                    fontSize: 13,
                    fontFamily: "Arial, sans-serif",
                    background: "rgba(0,0,0,0.18)",
                    borderRadius: 6,
                    padding: "2px 8px"
                }}>
                    {dateStr}
                </span>
            </div>
        </div>
    );
} 